import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-export-pages-layout',
  imports: [RouterOutlet],
  templateUrl: './export-pages-layout.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './export-pages-layout.component.scss',
})
export class ExportPagesLayoutComponent {}
